//行政月常规采购申请B
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
			<SelectFilterTable v-if='item.Property.Control=="SelectFilterTable"' @data-val='item' :template-data='templateData.TemplateContent.Controls'
			 :val-index='5'></SelectFilterTable>

		</div>

		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import SelectFilterTable from '../components/SelectFilterTable.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		getAdministrativeProgressive,
	} from '@/api/approval'
	import {
		getRelation,
		getDepartPrincipal
	} from '@/api/employee'
	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo,
		getDepartmentRelationByStructs
	} from '@/api/department'


	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			SelectFilterTable
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				isDisabled: false,
				flowId: null
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation(this.logInfo.EmpNo);
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法

			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var DepAssignment = true;
						var depart = res.result.departmentList[0]; // 已选的部门列表
						var departFullName = "";
						await getDepartmentInfo(depart.id).then(res => {
							departFullName = res.Body.FullName;
						});

						that.templateData.TemplateContent.Controls.forEach(async (item, index) => {

							if (item.Property.Title[0].Text == "流程部门") {
								if (departFullName.indexOf("非营业部") > -1 || departFullName.indexOf("华西区/原友信") > -1 || departFullName.indexOf(
										"华西区") > -1) {
									item.Value = "option-1601005120828";
									item.IsShow = false;
									// alert("非营业部");
								}
								if (departFullName.indexOf("住宅部") > -1) {
									item.Value = "option-1600932004491";
									item.IsShow = false;
									// alert("住宅部");
								}
								if (departFullName.indexOf("工商铺") > -1) {
									item.Value = "option-1600932004492";
									item.IsShow = false;
									// alert("工商铺商业运营中心");
								}
								if (departFullName.indexOf("房友圈") > -1) {
									// alert("房友圈");
									item.Value = "option-1600932020690";
									item.IsShow = false;
								}
								if (departFullName.indexOf("二级市场") > -1) {
									item.Value = "option-1601005104277";
									item.IsShow = false;
									// alert("二级市场支援中心");
								}
								if (departFullName.indexOf("按揭金融服务中心") > -1) {
									item.Value = "option-1601005114772";
									item.IsShow = false;
									// alert("汇瀚");
								}
								if (departFullName.indexOf("住宅部支援中心") > -1) {
									item.Value = "option-1601005120828";
									item.IsShow = false;
									// alert("非营业部");
								}
							}
							if (item.Property.Title[0].Text == "小战区区董") {
								item.Values = await that.getDepartmentRelation(depart.id, "区域董事", true)
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
								item.IsShow = false;
							}
							if (item.Property.Title[0].Text == "行政主任") {
								getDepartmentRelationByStructs(departFullName, "行政主任", false).then(res => {
									if (res.Body != null) {
										res.Body[0].Nodes.forEach((depData) => {
											if (depData.Items != null) {
												depData.Items.forEach((userData) => {
													if (userData.PositionName.indexOf("行政主任") > -1) {
														item.Values = [];
														var insertDat = [userData.EmpNo, userData.EmpName]
														item.Values.push(insertDat);
													}
												})
											}
										});
									}
									if (item.Values == null || item.Values.length == 0) {
										item.Values = [
											["SC24000029", "钟志斌"]
										]
									}
								})
								item.IsShow = false;

							}
							if (item.Property.Title[0].Text == "大战区区董") {
								item.IsShow = false;
								item.Values = await that.getDepartmentRelation(depart.id, "高级董事总经理", true)
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
							}
							if (item.Property.Title[0].Text == "区域总经理") {
								item.IsShow = false;
								item.Values = await that.getDepartmentRelation(depart.id, "总经理", true)
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
							}
							if (item.Property.Title[0].Text == "部门负责人") {
								item.IsShow = false;
								await getDepartPrincipal(departFullName).then(res => {
									var DepartPrincipal = res.Body;
									if (DepartPrincipal != null) {
										var data = new Array();
										for (var i = 0; i < DepartPrincipal.length; i++) {
											var arr = new Array(2)
											arr[0] = DepartPrincipal[i].empNo;
											arr[1] = DepartPrincipal[i].empName;
											data.push(arr);
										}
										item.Values = data;
									} else {
										item.Values = [
											["SC02120002", "卢华"]
										]
									}
								})
							}
						})
						if (DepAssignment) {
							dataVal.Values = [];
							dataVal.Values.push([depart.id, depart.name]);
							dataVal.Value = depart.name;
						} else {
							dataVal.Values = [];
							dataVal.Value = "";
						}
					}
				})
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var departs = this.logInfo.fullName;
				if (departs.indexOf("房友圈") == -1 &&
					departs.indexOf("工商铺") == -1 &&
					departs.indexOf("原友信") == -1 &&
					departs.indexOf("二级市场营运中心") == -1 &&
					departs.indexOf("住宅部") == -1 &&
					departs.indexOf("按揭金融服务中心") == -1 &&
					departs.indexOf("非营业") == -1 &&
					departs.indexOf("华西区") == -1 &&
					this.isDisabled == false
				) {
					this.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "小战区区董") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "行政主任") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "流程部门") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大战区区董") {
							item.IsShow = false;
							item.Values = ["SC24000029", "钟志斌"];
						}
						if (item.Property.Title[0].Text == "部门负责人") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}

						if (item.Property.Title[0].Text == "区域总经理") {
							item.IsShow = false;
							item.Values = [
								["SC24000029", "钟志斌"]
							];
						}
						if (item.Property.Title[0].Text == "人员") {
							item.Property.Title[0].Text == "姓名";
						}
						if (item.Property.Title[0].Text == "申请内容") {
							item.Config.Table.Children.forEach(async (sonData) => {
								if (sonData.Property.Title[0].Text == "种类") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
									sonData.Options = [];
									await getAdministrativeProgressive("", "", "", "", "", "").then(res => {
										res.Body.forEach(item => {
											var data = {
												"Key": item,
												"Value": item
											};
											sonData.Options.push(data);
										});
									});

								}
								if (sonData.Property.Title[0].Text == "物品名称") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "规格型号") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单位") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单价") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}

							});
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo, this.flowId);
					this.listLoading = false;
				});

				function sleep(d) {
					for (var t = Date.now(); Date.now() - t <= d;);
				}
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if (type == 'compute') {
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit: async function() {
				var that = this;
				var IsReturn = false;
				for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
					var item = this.templateData.TemplateContent.Controls[i];
					if (item.Property.Title[0].Text.indexOf("申请内容") > -1) {
						var type = "";
						var ItemName = "";
						var SpecificationModel = "";
						var Company = "";
						var UnitPrice = "";
						item.Config.Table.Children.forEach((sonData) => {
							if (sonData.Property.Title[0].Text == "种类") {
								type = sonData.Value;
							}
							if (sonData.Property.Title[0].Text == "物品名称") {
								ItemName = sonData.Value;
							}
							if (sonData.Property.Title[0].Text == "规格型号") {
								SpecificationModel = sonData.Value;
							}
							if (sonData.Property.Title[0].Text == "单位") {
								Company = sonData.Value;
							}
							if (sonData.Property.Title[0].Text == "单价") {
								UnitPrice = sonData.Value;
							}
						});
						await getAdministrativeProgressive(type.replace(/\+/g, '%2B'), ItemName.replace(/\+/g, '%2B'),
							SpecificationModel.replace(/\+/g, '%2B'), Company.replace(/\+/g, '%2B'), UnitPrice.replace(/\+/g, '%2B'), 6).then(
							res => {
								if (res.Body.length == 0) {
									IsReturn = true;
									that.Message({
										message: '申请内容数据校验失败',
										type: 'error',
										duration: 3 * 1000
									});
								}
							});
					}
				}
				if (IsReturn) {
					return;
				}
				await this.templateData.TemplateContent.Controls.forEach((item) => {
					if (item.Property.Title[0].Text.indexOf("申请内容") > -1) {
						item.Config.Table.Children.forEach((sonData) => {
							if (sonData.Property.Title[0].Text == "种类") {
								sonData.Property.Control = "Text";
								sonData.filterable = true;
							}
							if (sonData.Property.Title[0].Text == "物品名称") {
								sonData.Property.Control = "Text";
								sonData.filterable = true;
							}
							if (sonData.Property.Title[0].Text == "规格型号") {
								sonData.Property.Control = "Text";
								sonData.filterable = true;
							}
							if (sonData.Property.Title[0].Text == "单位") {
								sonData.Property.Control = "Text";
								sonData.filterable = true;
							}
							if (sonData.Property.Title[0].Text == "单价") {
								sonData.Property.Control = "Money";
								sonData.filterable = true;
							}
						});
					}
				});
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
						var item = this.templateData.TemplateContent.Controls[i];
						if (item.Property.Title[0].Text == "申请内容") {
							item.Config.Table.Children.forEach(async (sonData) => {
								if (sonData.Property.Title[0].Text == "种类") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
									sonData.Options = [];
									await getAdministrativeProgressive("", "", "", "", "", "").then(res => {
										res.Body.forEach(item => {
											var data = {
												"Key": item,
												"Value": item
											};
											sonData.Options.push(data);
										});
									});

								}
								if (sonData.Property.Title[0].Text == "物品名称") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "规格型号") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单位") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单价") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
							});
						}
					}
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
					for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
						var item = this.templateData.TemplateContent.Controls[i];
						if (item.Property.Title[0].Text == "申请内容") {
							item.Config.Table.Children.forEach(async (sonData) => {
								if (sonData.Property.Title[0].Text == "种类") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
									sonData.Options = [];
									await getAdministrativeProgressive("", "", "", "", "", "").then(res => {
										res.Body.forEach(item => {
											var data = {
												"Key": item,
												"Value": item
											};
											sonData.Options.push(data);
										});
									});

								}
								if (sonData.Property.Title[0].Text == "物品名称") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "规格型号") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单位") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单价") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
							});
						}
					}
				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
